import React from "react";
import { FormControlLabel, Switch } from "@mui/material";

const AppSwitch = ({ label = "", ...switchProps }) => {
  return (
    <FormControlLabel
      control={<Switch {...switchProps} checked={!!switchProps.value} />}
      {...{ label }}
    />
  );
};

export default AppSwitch;
